import { recipe } from "@vanilla-extract/recipes";

import { theme } from "../../theme/css/theme.css";

export const rulerStyle = recipe({
  base: {
    border: 0,
    flexShrink: 0,
    flexGrow: 0,
  },
  variants: {
    variant: {
      default: {
        backgroundColor: theme.colors.defaultBorder,
      },
      soft: {
        backgroundColor: theme.colors.softBorder,
      },
      currentColor: {
        backgroundColor: "currentColor",
        opacity: 0.25,
      },
      background: {
        backgroundColor: theme.colors.background,
      },
      border: {
        backgroundColor: theme.colors.inputBorder,
      },
    },
    direction: {
      horizontal: {
        width: "var(--ruler-width, 100%)",
        height: "1px",
      },
      vertical: {
        minHeight: "100%",
        width: "1px",
        flexGrow: 0,
      },
    },
  },
  defaultVariants: {
    variant: "default",
    direction: "horizontal",
  },
});
